export default "__VITE_ASSET__PwxgsrLn__"